/* gz-ui.js - clean-room UI elements for the GZ (Gardenizi) sections on Dawn 16.
 * Behaviour derived from the gz-*.liquid markup; Dawn 16 global.js / media-gallery.js /
 * product-modal.js / product-model.js / share.js / pickup-availability.js used as reference.
 * Remove together with all gz-* files. */
(function () {
  'use strict';

  /* ---------- helpers ---------- */

  function define(name, cls) {
    if (window.GZ && typeof window.GZ.define === 'function') return window.GZ.define(name, cls);
    if (!customElements.get(name)) customElements.define(name, cls);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function debounceFn(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function parseHTML(text) {
    return new DOMParser().parseFromString(text, 'text/html');
  }

  function sectionIdOf(el) {
    var holder = el.closest('[data-section]');
    if (holder && holder.dataset.section) return holder.dataset.section;
    var section = el.closest('.shopify-section');
    return section ? section.id.replace('shopify-section-', '') : null;
  }

  function doTrapFocus(container, elementToFocus) {
    if (typeof window.trapFocus === 'function') window.trapFocus(container, elementToFocus);
    else if (elementToFocus) elementToFocus.focus();
  }

  function doRemoveTrapFocus(elementToFocus) {
    if (typeof window.removeTrapFocus === 'function') window.removeTrapFocus(elementToFocus || null);
    else if (elementToFocus) elementToFocus.focus();
  }

  // Pause iframes / models / user videos. Muted autoplay internal videos are left alone.
  function pauseMedia(except) {
    qsa('.js-youtube').forEach(function (frame) {
      if (except && except.contains(frame)) return;
      if (frame.contentWindow) frame.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    });
    qsa('.js-vimeo').forEach(function (frame) {
      if (except && except.contains(frame)) return;
      if (frame.contentWindow) frame.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    qsa('video').forEach(function (video) {
      if (except && except.contains(video)) return;
      var internal = video.closest('gz-internal-video');
      if (internal && internal.dataset.autoplay === 'true' && video.muted) return;
      if (!video.paused) video.pause();
    });
    qsa('gz-product-model').forEach(function (model) {
      if (except && except.contains(model)) return;
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }

  function scrollToElement(el) {
    if (!el) return;
    var header = document.querySelector('sticky-header, .section-header');
    var offset = header ? Math.min(header.getBoundingClientRect().height, 150) : 0;
    var top = el.getBoundingClientRect().top + window.pageYOffset - offset - 20;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  }

  /* ---------- main product add-to-cart trigger (sticky ATC, slideshow ATC buttons) ---------- */

  function findMainForm(sectionId) {
    var form = sectionId ? document.getElementById('product-form-' + sectionId) : null;
    if (!form) form = document.querySelector('gz-product-form[data-main="true"] form[id^="product-form-"]');
    if (!form) form = document.querySelector('form[id^="product-form-"]');
    return form;
  }

  function mirrorLoading(source, mainBtn) {
    if (!source) return;
    source.classList.add('loading');
    source.setAttribute('aria-disabled', 'true');
    var sawLoading = false;
    var observer = null;
    var timer = null;
    var done = function () {
      source.classList.remove('loading');
      source.removeAttribute('aria-disabled');
      if (observer) observer.disconnect();
      clearTimeout(timer);
      document.removeEventListener('gz:cart-updated', done);
    };
    if (mainBtn) {
      observer = new MutationObserver(function () {
        var loading = mainBtn.classList.contains('loading') || mainBtn.getAttribute('aria-disabled') === 'true';
        if (loading) sawLoading = true;
        else if (sawLoading) done();
      });
      observer.observe(mainBtn, { attributes: true, attributeFilter: ['class', 'aria-disabled'] });
    }
    document.addEventListener('gz:cart-updated', done);
    timer = setTimeout(done, 8000);
  }

  function triggerMainAtc(sectionId, source) {
    var form = findMainForm(sectionId);
    if (!form) return false;
    var formSection = (form.getAttribute('id') || '').replace('product-form-', '');
    var mainBtn = document.getElementById('ProductSubmitButton-' + formSection) || form.querySelector('[type="submit"]');
    if (mainBtn && !mainBtn.disabled && mainBtn.getAttribute('aria-disabled') !== 'true') {
      mirrorLoading(source, mainBtn);
      mainBtn.click();
      return true;
    }
    if (!mainBtn && typeof form.requestSubmit === 'function') {
      mirrorLoading(source, null);
      form.requestSubmit();
      return true;
    }
    // Main button blocked (required fields etc.): bring the form into view so the reason is visible.
    scrollToElement(mainBtn || form);
    return false;
  }

  // `.main-product-atc` type="button" buttons living outside any gz-product-form (e.g. gz-slideshow
  // "atc" buttons). Buttons inside gz-product-form are core's; the sticky bar handles its own.
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || !event.target.closest) return;
    var btn = event.target.closest('.main-product-atc');
    if (!btn || btn.type === 'submit' || btn.disabled) return;
    if (btn.closest('gz-product-form') || btn.closest('gz-sticky-atc')) return;
    event.preventDefault();
    var formAttr = btn.getAttribute('form');
    var sectionId = formAttr && formAttr.indexOf('product-form-') === 0 ? formAttr.replace('product-form-', '') : null;
    triggerMainAtc(sectionId, btn);
  });

  /* ---------- gz-slider-component ---------- */

  class GzSlider extends HTMLElement {
    connectedCallback() {
      if (this._sliderInit) return;
      this._sliderInit = true;
      this.slider = this.querySelector('[id^="Slider-"]');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
      this.currentPageElement = this.querySelector('.slider-counter--current');
      this.pageTotalElement = this.querySelector('.slider-counter--total');
      this.enableSliderLooping = false;
      if (!this.slider) return;

      this.resetPages();
      if (window.ResizeObserver) {
        this._resizeObserver = new ResizeObserver(() => this.initPages());
        this._resizeObserver.observe(this.slider);
      }
      this.slider.addEventListener('scroll', () => this.update(), { passive: true });
      if (this.prevButton) this.prevButton.addEventListener('click', (e) => this.onButtonClick(e));
      if (this.nextButton) this.nextButton.addEventListener('click', (e) => this.onButtonClick(e));
      this.dotLinks().forEach((link) => link.addEventListener('click', (e) => this.linkToSlide(e)));
      this.afterSliderInit();
    }

    afterSliderInit() {}

    dotLinks() {
      return qsa('.slider-counter__link', this).filter((el) => !el.closest('noscript'));
    }

    visibleDotLinks() {
      return this.dotLinks().filter((el) => !el.classList.contains('hidden'));
    }

    resetPages() {
      if (!this.slider) return;
      this.sliderItems = Array.prototype.filter.call(this.slider.children, (el) => /^Slide-/.test(el.id));
      this.initPages();
    }

    initPages() {
      this.sliderItemsToShow = (this.sliderItems || []).filter((el) => el.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) {
        this.sliderItemOffset = 0;
        this.totalPages = this.sliderItemsToShow.length;
        this.currentPage = 1;
        this.update();
        return;
      }
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      if (this.sliderItemOffset <= 0) this.sliderItemOffset = this.sliderItemsToShow[0].clientWidth || 1;
      this.slidesPerPage = Math.max(
        1,
        Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset)
      );
      this.totalPages = Math.max(1, this.sliderItemsToShow.length - this.slidesPerPage + 1);
      this.update();
    }

    update() {
      if (!this.slider) return;
      var previousPage = this.currentPage;
      if (this.sliderItemOffset) {
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
        this.currentPage = Math.min(Math.max(this.currentPage, 1), this.sliderItemsToShow.length || 1);
      } else {
        this.currentPage = 1;
      }

      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages || 1;
      }

      var dots = this.visibleDotLinks();
      dots.forEach((link, index) => {
        var active = index === this.currentPage - 1;
        link.classList.toggle('slider-counter__link--active', active);
        if (active) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });

      if (this.currentPage !== previousPage) {
        var currentElement = this.sliderItemsToShow[this.currentPage - 1];
        this.onSlideChange(currentElement);
        this.dispatchEvent(
          new CustomEvent('slideChanged', { detail: { currentPage: this.currentPage, currentElement: currentElement } })
        );
      }

      if (this.enableSliderLooping || !this.prevButton || !this.nextButton) return;
      var items = this.sliderItemsToShow;
      if (!items.length || (this.isSlideVisible(items[0]) && this.slider.scrollLeft <= 0)) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
      if (!items.length || this.isSlideVisible(items[items.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }

    onSlideChange(currentElement) {
      if (!currentElement) return;
      if (this.dataset.updateActive === 'true') {
        this.sliderItems.forEach((el) => el.classList.toggle('is-active', el === currentElement));
      }
      if (this.dataset.pauseVideos === 'true') {
        this.sliderItems.forEach((el) => {
          if (el === currentElement) return;
          qsa('video', el).forEach((video) => {
            if (!video.paused) video.pause();
          });
          qsa('.js-youtube', el).forEach((frame) => {
            if (frame.contentWindow)
              frame.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          });
          qsa('.js-vimeo', el).forEach((frame) => {
            if (frame.contentWindow) frame.contentWindow.postMessage('{"method":"pause"}', '*');
          });
        });
      }
    }

    isSlideVisible(element, offset) {
      offset = offset || 0;
      var lastVisible = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return (
        element.offsetLeft + element.clientWidth <= lastVisible + 1 && element.offsetLeft >= this.slider.scrollLeft - 1
      );
    }

    onButtonClick(event) {
      event.preventDefault();
      if (!this.sliderItemOffset) return;
      var step = parseInt(event.currentTarget.dataset.step || 1, 10);
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollLeft + step * this.sliderItemOffset
          : this.slider.scrollLeft - step * this.sliderItemOffset;
      this.setSlidePosition(this.slideScrollPosition);
    }

    linkToSlide(event) {
      event.preventDefault();
      var index = this.visibleDotLinks().indexOf(event.currentTarget);
      this.goToIndex(index);
    }

    goToIndex(index) {
      var target = this.sliderItemsToShow[index];
      if (!target) return;
      this.setSlidePosition(target.offsetLeft - this.sliderItemsToShow[0].offsetLeft);
    }

    setSlidePosition(position) {
      this.slider.scrollTo({ left: position });
    }
  }
  define('gz-slider-component', GzSlider);

  /* ---------- gz-slideshow-component ---------- */

  class GzSlideshow extends GzSlider {
    afterSliderInit() {
      this.enableSliderLooping = true;
      if (this.prevButton) this.prevButton.removeAttribute('disabled');
      if (this.nextButton) this.nextButton.removeAttribute('disabled');
      this.slider.addEventListener('scroll', debounceFn(() => this.setSlideVisibility(), 100), { passive: true });
      this.setSlideVisibility();

      this.autoplayButton = this.querySelector('.slideshow__autoplay');
      if (this.slider.dataset.autoplay === 'true') this.setAutoPlay();

      // Theme editor: show the selected block's slide.
      this.addEventListener('shopify:block:select', (event) => {
        var slide = event.target.closest('[id^="Slide-"]');
        var index = this.sliderItemsToShow.indexOf(slide);
        if (index < 0) return;
        this._editorPaused = true;
        this.pause();
        this.goToIndex(index);
      });
      this.addEventListener('shopify:block:deselect', () => {
        this._editorPaused = false;
        if (this.autoplayActive && this.userWantsPlay) this.play();
      });
    }

    setAutoPlay() {
      this.autoplaySpeed = (parseFloat(this.slider.dataset.speed) || 5) * 1000;
      this.autoplayActive = true;
      this.userWantsPlay = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.resume());
      this.addEventListener('focusin', (event) => {
        if (this.autoplayButton && this.autoplayButton.contains(event.target)) return;
        this.pause();
      });
      this.addEventListener('focusout', () => this.resume());
      if (this.autoplayButton) {
        this.autoplayButton.addEventListener('click', () => {
          this.userWantsPlay = !this.userWantsPlay;
          this.togglePlayButtonState(!this.userWantsPlay);
          if (this.userWantsPlay) this.play();
          else this.pause();
        });
      }
      this.togglePlayButtonState(!this.userWantsPlay);
      if (this.userWantsPlay) this.play();
    }

    resume() {
      if (this.autoplayActive && this.userWantsPlay && !this._editorPaused) this.play();
    }

    play() {
      this.slider.setAttribute('aria-live', 'off');
      clearInterval(this.autoplay);
      this.autoplay = setInterval(() => this.autoRotateSlides(), this.autoplaySpeed);
    }

    pause() {
      this.slider.setAttribute('aria-live', 'polite');
      clearInterval(this.autoplay);
    }

    connectedCallback() {
      var reconnect = this._sliderInit;
      super.connectedCallback();
      if (reconnect) this.resume();
    }

    disconnectedCallback() {
      clearInterval(this.autoplay);
    }

    togglePlayButtonState(paused) {
      if (!this.autoplayButton) return;
      var strings = window.accessibilityStrings || {};
      this.autoplayButton.classList.toggle('slideshow__autoplay--paused', paused);
      var label = paused ? strings.playSlideshow : strings.pauseSlideshow;
      if (label) this.autoplayButton.setAttribute('aria-label', label);
    }

    autoRotateSlides() {
      var count = this.sliderItemsToShow.length;
      if (count < 2) return;
      var position = this.currentPage >= count ? 0 : this.slider.scrollLeft + this.sliderItemOffset;
      this.setSlidePosition(position);
    }

    onButtonClick(event) {
      event.preventDefault();
      if (!this.sliderItemOffset) return;
      var count = this.sliderItemsToShow.length;
      var isNext = event.currentTarget.name === 'next';
      var position;
      if (isNext && this.currentPage >= count) position = 0;
      else if (!isNext && this.currentPage <= 1) position = this.sliderItemOffset * (count - 1);
      else position = this.slider.scrollLeft + (isNext ? 1 : -1) * this.sliderItemOffset;
      this.setSlidePosition(position);
    }

    update() {
      super.update();
      if (this.prevButton) this.prevButton.removeAttribute('disabled');
      if (this.nextButton) this.nextButton.removeAttribute('disabled');
    }

    setSlideVisibility() {
      (this.sliderItemsToShow || []).forEach((item, index) => {
        var current = index === this.currentPage - 1;
        qsa('a, button, input, select', item).forEach((el) => {
          if (current) el.removeAttribute('tabindex');
          else el.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', current ? 'false' : 'true');
        if (current) item.removeAttribute('tabindex');
        else item.setAttribute('tabindex', '-1');
      });
    }
  }
  define('gz-slideshow-component', GzSlideshow);

  /* ---------- gz-media-gallery ---------- */

  class GzMediaGallery extends HTMLElement {
    constructor() {
      super();
      this.onVariantChange = this.onVariantChange.bind(this);
    }

    connectedCallback() {
      document.addEventListener('gz:variant-change', this.onVariantChange);
      if (this._init) return;
      this._init = true;
      this.liveRegion = this.querySelector('[id^="GalleryStatus"]');
      this.viewer = this.querySelector('[id^="GalleryViewer"]');
      this.thumbnails = this.querySelector('[id^="GalleryThumbnails"]');
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.viewer) return;

      if (this.thumbnails) {
        this.viewer.addEventListener(
          'slideChanged',
          debounceFn((event) => {
            var current = event.detail.currentElement;
            if (!current) return;
            this.setActiveThumbnail(this.thumbnails.querySelector('[data-target="' + current.dataset.mediaId + '"]'));
          }, 300)
        );
        qsa('[data-target]', this.thumbnails).forEach((item) => {
          var button = item.querySelector('button');
          if (button) button.addEventListener('click', () => this.setActiveMedia(item.dataset.target, false, true));
        });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('gz:variant-change', this.onVariantChange);
    }

    onVariantChange(event) {
      var detail = event.detail || {};
      if (detail.sectionId !== this.dataset.section || !detail.variant) return;
      var variant = detail.variant;
      var option = this.dataset.filteringOption;
      if (option && variant[option] != null) this.filterMedia(String(variant[option]));
      if (variant.featured_media && variant.featured_media.id) {
        this.setActiveMedia(this.dataset.section + '-' + variant.featured_media.id, this.dataset.disablePrepend !== 'true', false);
      } else if (option) {
        var first = this.viewer && this.viewer.querySelector('[data-media-id]:not(.hidden)');
        if (first) this.setActiveMedia(first.dataset.mediaId, false, false);
      }
    }

    filterMedia(value) {
      var match = function (el) {
        var alt = el.dataset.alt;
        return alt === value || alt === 'always_display';
      };
      qsa('[data-media-id][data-alt]', this.viewer).forEach((el) => el.classList.toggle('hidden', !match(el)));
      if (this.thumbnails) {
        qsa('[data-target][data-alt]', this.thumbnails).forEach((el) => el.classList.toggle('hidden', !match(el)));
      }
      qsa('.slider-counter__link[data-alt]', this).forEach((el) => el.classList.toggle('hidden', !match(el)));
      if (typeof this.viewer.resetPages === 'function') this.viewer.resetPages();
      if (this.thumbnails && typeof this.thumbnails.resetPages === 'function') this.thumbnails.resetPages();
    }

    setActiveMedia(mediaId, prepend, fromUser) {
      if (!this.viewer) return;
      var activeMedia =
        this.viewer.querySelector('[data-media-id="' + mediaId + '"]') || this.viewer.querySelector('[data-media-id]');
      if (!activeMedia) return;
      qsa('[data-media-id]', this.viewer).forEach((el) => el.classList.remove('is-active'));
      activeMedia.classList.add('is-active');

      var activeThumbnail = this.thumbnails
        ? this.thumbnails.querySelector('[data-target="' + activeMedia.dataset.mediaId + '"]')
        : null;

      if (prepend) {
        if (activeMedia.parentElement.firstElementChild !== activeMedia) activeMedia.parentElement.prepend(activeMedia);
        if (activeThumbnail && activeThumbnail.parentElement.firstElementChild !== activeThumbnail) {
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (typeof this.viewer.resetPages === 'function') this.viewer.resetPages();
        if (this.thumbnails && typeof this.thumbnails.resetPages === 'function') this.thumbnails.resetPages();
      }

      window.setTimeout(() => {
        if (!this.mql.matches || this.thumbnails) {
          var list = activeMedia.parentElement;
          var first = Array.prototype.find.call(list.children, (el) => el.clientWidth > 0);
          list.scrollTo({ left: activeMedia.offsetLeft - (first ? first.offsetLeft : 0) });
        }
      });

      pauseMedia();
      if (fromUser) {
        var deferred = activeMedia.querySelector('.deferred-media');
        if (deferred && typeof deferred.loadContent === 'function') deferred.loadContent(false);
      }

      if (activeThumbnail) {
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
    }

    setActiveThumbnail(thumbnail) {
      if (!this.thumbnails || !thumbnail) return;
      qsa('button', this.thumbnails).forEach((el) => el.removeAttribute('aria-current'));
      var button = thumbnail.querySelector('button');
      if (button) button.setAttribute('aria-current', 'true');
      var slider = this.thumbnails.slider;
      if (!slider) return;
      if (typeof this.thumbnails.isSlideVisible === 'function' && this.thumbnails.isSlideVisible(thumbnail, 10)) return;
      slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      var image = activeItem.querySelector('.product__modal-opener--image img');
      var strings = window.accessibilityStrings || {};
      if (!image || !this.liveRegion || !strings.imageAvailable) return;
      this.liveRegion.setAttribute('aria-hidden', 'false');
      this.liveRegion.textContent = strings.imageAvailable.replace('[index]', position);
      setTimeout(() => this.liveRegion.setAttribute('aria-hidden', 'true'), 2000);
    }
  }
  define('gz-media-gallery', GzMediaGallery);

  /* ---------- modals ---------- */

  // Modals stay where Liquid renders them (styles are scoped to `.gz-scope`, so they are NOT
  // moved to <body> like Dawn does).
  class GzModalDialog extends HTMLElement {
    connectedCallback() {
      if (this._modalInit) return;
      this._modalInit = true;
      var close = this.querySelector('[id^="ModalClose-"]');
      if (close) close.addEventListener('click', () => this.hide());
      this.addEventListener('keyup', (event) => {
        if (event.code && event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
      if (this.classList.contains('media-modal')) {
        this.addEventListener('pointerup', (event) => {
          if (event.pointerType === 'mouse' && !event.target.closest('gz-deferred-media, gz-product-model, [id^="ModalClose-"]')) this.hide();
        });
      } else {
        this.addEventListener('click', (event) => {
          if (event.target === this) this.hide();
        });
      }
    }

    show(opener) {
      this.openedBy = opener;
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
      var dialog = this.querySelector('[role="dialog"]');
      doTrapFocus(this, dialog);
      pauseMedia();
    }

    hide() {
      if (!this.hasAttribute('open')) return;
      document.body.classList.remove('overflow-hidden');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
      this.removeAttribute('open');
      doRemoveTrapFocus(this.openedBy);
      pauseMedia();
    }
  }
  define('gz-modal-dialog', GzModalDialog);

  class GzProductModal extends GzModalDialog {
    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      var mediaId = this.openedBy && this.openedBy.getAttribute('data-media-id');
      var content = this.querySelector('[role="document"]');
      if (!mediaId || !content) return;
      var items = Array.prototype.filter.call(content.children, (el) => el.hasAttribute('data-media-id'));
      items.forEach((el) => el.classList.toggle('active', el.getAttribute('data-media-id') === mediaId));
      var activeMedia = items.find((el) => el.getAttribute('data-media-id') === mediaId);
      if (!activeMedia) return;
      activeMedia.scrollIntoView();
      content.scrollLeft = (activeMedia.clientWidth - content.clientWidth) / 2;
      var template = activeMedia.querySelector('template');
      if (
        activeMedia.nodeName === 'GZ-DEFERRED-MEDIA' &&
        template &&
        template.content.querySelector('.js-youtube') &&
        typeof activeMedia.loadContent === 'function'
      ) {
        activeMedia.loadContent();
      }
    }
  }
  define('gz-product-modal', GzProductModal);

  class GzModalOpener extends HTMLElement {
    connectedCallback() {
      if (this._openerInit) return;
      this._openerInit = true;
      var button = this.querySelector('.product__media-toggle') || this.querySelector('button');
      if (!button) return;
      button.addEventListener('click', () => {
        var selector = this.getAttribute('data-modal');
        var modal = selector ? document.querySelector(selector) : null;
        if (modal && typeof modal.show === 'function') modal.show(button);
      });
    }
  }
  define('gz-modal-opener', GzModalOpener);

  /* ---------- deferred media / 3D model ---------- */

  class GzDeferredMedia extends HTMLElement {
    connectedCallback() {
      if (this._deferredInit) return;
      this._deferredInit = true;
      var poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (poster) poster.addEventListener('click', () => this.loadContent());
    }

    loadContent(focus) {
      if (focus === undefined) focus = true;
      pauseMedia();
      if (this.getAttribute('loaded')) return;
      var template = this.querySelector('template');
      if (!template || !template.content.firstElementChild) return;
      var wrapper = document.createElement('div');
      wrapper.appendChild(template.content.firstElementChild.cloneNode(true));
      var media = wrapper.querySelector('video, model-viewer, iframe');
      if (!media) return;
      this.setAttribute('loaded', 'true');
      var element = this.appendChild(media);
      if (focus) element.focus();
      if (element.nodeName === 'VIDEO' && element.getAttribute('autoplay')) {
        var p = element.play();
        if (p && p.catch) p.catch(function () {});
      }
      var formerStyle = element.getAttribute('style');
      element.setAttribute('style', 'display: block;');
      window.setTimeout(function () {
        if (formerStyle) element.setAttribute('style', formerStyle);
        else element.removeAttribute('style');
      }, 0);
    }
  }
  define('gz-deferred-media', GzDeferredMedia);

  class GzProductModel extends GzDeferredMedia {
    loadContent(focus) {
      super.loadContent(focus);
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
      window.Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: (errors) => {
            if (errors || !window.Shopify.ModelViewerUI) return;
            var viewer = this.querySelector('model-viewer');
            if (viewer && !this.modelViewerUI) this.modelViewerUI = new window.Shopify.ModelViewerUI(viewer);
          },
        },
      ]);
    }
  }
  define('gz-product-model', GzProductModel);

  // "View in your space" (AR) buttons: register models from #ProductJSON-<id>.
  // Skipped when Dawn's own product-model.js is on the page (it does the same).
  function setupShopifyXR() {
    if (window.ProductModel || !document.querySelector('[id^="ProductJSON-"]')) return;
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    var register = function () {
      qsa('[id^="ProductJSON-"]').forEach(function (json) {
        try {
          window.ShopifyXR.addModels(JSON.parse(json.textContent));
        } catch (e) {
          /* ignore malformed JSON */
        }
        json.remove();
      });
      window.ShopifyXR.setupXRElements();
    };
    window.Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: function (errors) {
          if (errors) return;
          if (window.ShopifyXR) register();
          else document.addEventListener('shopify_xr_initialized', register, { once: true });
        },
      },
    ]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupShopifyXR);
  else setupShopifyXR();
  document.addEventListener('shopify:section:load', setupShopifyXR);

  /* ---------- gz-internal-video ---------- */

  class GzInternalVideo extends HTMLElement {
    connectedCallback() {
      if (!this._videoInit) this.init();
      if (this._io) this._io.observe(this);
      this.observeSlide();
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
      if (this._slideObserver) this._slideObserver.disconnect();
    }

    init() {
      this._videoInit = true;
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.autoplay = this.dataset.autoplay === 'true';
      this.playButton = this.querySelector('.internal-video__play');
      this.soundButton = this.querySelector('.internal-video__sound-btn');
      this.timeline = this.querySelector('.internal-video__timeline');
      this.userPaused = false;

      if (this.playButton) {
        this.playButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (this.video.paused) {
            this.userPaused = false;
            this.play();
          } else {
            this.userPaused = true;
            this.pause();
          }
        });
      }

      if (this.soundButton) {
        this.soundButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.setMuted(!this.video.muted);
          if (this.video.paused && !this.video.muted) this.play();
        });
      }

      var v = this.video;
      v.addEventListener('play', () => this.classList.add('internal-video--playing'));
      v.addEventListener('playing', () => this.classList.remove('internal-video--loading'));
      v.addEventListener('canplay', () => this.classList.remove('internal-video--loading'));
      v.addEventListener('waiting', () => {
        if (!v.paused) this.classList.add('internal-video--loading');
      });
      v.addEventListener('pause', () => {
        this.classList.remove('internal-video--playing', 'internal-video--loading');
      });
      v.addEventListener('ended', () => this.classList.remove('internal-video--playing'));
      v.addEventListener('volumechange', () => this.classList.toggle('internal-video--muted', v.muted));
      v.addEventListener('timeupdate', () => this.updateTimeline());
      this.classList.toggle('internal-video--muted', v.muted || this.autoplay);
      if (!this.autoplay) this.classList.remove('internal-video--playing');

      if (this.timeline) this.setupTimeline();

      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver(
          (entries) => {
            var entry = entries[entries.length - 1];
            this.inView = entry.isIntersecting;
            if (entry.isIntersecting) {
              if (this.autoplay && !this.userPaused && this.isSlideActive()) this.play(true);
            } else if (!v.paused) {
              this.pause();
            }
          },
          { threshold: 0.25 }
        );
      } else if (this.autoplay) {
        this.play(true);
      }
    }

    // Inside a Splide slider: react when our slide stops/starts being the active one.
    observeSlide() {
      var slide = this.closest('.splide__slide');
      if (!slide || !this.video) return;
      if (this._slideObserver) this._slideObserver.disconnect();
      var wasActive = slide.classList.contains('is-active');
      this._slideObserver = new MutationObserver(() => {
        var active = slide.classList.contains('is-active');
        if (active === wasActive) return;
        wasActive = active;
        if (!active) this.onInactive();
        else if (this.autoplay && !this.userPaused && this.inView !== false) this.play(true);
      });
      this._slideObserver.observe(slide, { attributes: true, attributeFilter: ['class'] });
    }

    isSlideActive() {
      var slide = this.closest('.splide__slide');
      if (!slide) return true;
      var splide = slide.closest('.splide');
      if (!splide || !splide.classList.contains('is-initialized')) return true;
      return slide.classList.contains('is-active') || slide.classList.contains('is-visible');
    }

    onInactive() {
      var action = this.dataset.actionOnInactive;
      if (action === 'none') return;
      if (action === 'mute') this.setMuted(true);
      else this.pause();
    }

    loadSources() {
      var changed = false;
      qsa('source[data-src]', this.video).forEach((source) => {
        source.setAttribute('src', source.getAttribute('data-src'));
        source.removeAttribute('data-src');
        changed = true;
      });
      if (changed) this.video.load();
    }

    play(auto) {
      if (!this.video) return;
      this.loadSources();
      if (auto) this.video.muted = true;
      if (!auto) pauseMedia(this);
      if (this.video.readyState < 3) this.classList.add('internal-video--loading');
      this.classList.add('internal-video--playing');
      var p = this.video.play();
      if (p && p.catch) {
        p.catch(() => {
          this.classList.remove('internal-video--playing', 'internal-video--loading');
        });
      }
    }

    pause() {
      if (this.video && !this.video.paused) this.video.pause();
    }

    mute() {
      this.setMuted(true);
    }

    setMuted(muted) {
      if (!this.video) return;
      this.video.muted = muted;
      if (!muted) this.video.removeAttribute('muted');
      this.classList.toggle('internal-video--muted', muted);
    }

    updateTimeline() {
      if (!this.timeline || !this.video.duration) return;
      var pct = (this.video.currentTime / this.video.duration) * 100;
      this.timeline.style.setProperty('--completed', pct + '%');
    }

    setupTimeline() {
      var dragging = false;
      var seek = (event) => {
        if (!this.video.duration) return;
        var rect = this.timeline.getBoundingClientRect();
        var ratio = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 1);
        this.video.currentTime = ratio * this.video.duration;
        this.updateTimeline();
      };
      this.timeline.addEventListener('pointerdown', (event) => {
        event.preventDefault();
        event.stopPropagation();
        dragging = true;
        if (this.timeline.setPointerCapture) this.timeline.setPointerCapture(event.pointerId);
        seek(event);
      });
      this.timeline.addEventListener('pointermove', (event) => {
        if (dragging) seek(event);
      });
      var stop = () => {
        dragging = false;
      };
      this.timeline.addEventListener('pointerup', stop);
      this.timeline.addEventListener('pointercancel', stop);
      this.timeline.addEventListener('click', (event) => event.stopPropagation());
    }
  }
  define('gz-internal-video', GzInternalVideo);

  /* ---------- gz-share-button ---------- */

  class GzShareButton extends HTMLElement {
    constructor() {
      super();
      this.onVariantChange = this.onVariantChange.bind(this);
    }

    connectedCallback() {
      document.addEventListener('gz:variant-change', this.onVariantChange);
      if (this._shareInit) return;
      this._shareInit = true;
      this.details = this.querySelector('details');
      this.shareButton = this.querySelector(':scope > button');
      this.summary = this.querySelector('summary');
      this.closeButton = this.querySelector('.share-button__close');
      this.copyButton = this.querySelector('.share-button__copy');
      this.successMessage = this.querySelector('[id^="ShareMessage"]');
      this.urlInput = this.querySelector('input');

      if (navigator.share && this.shareButton) {
        if (this.details) this.details.setAttribute('hidden', '');
        this.shareButton.classList.remove('hidden');
        this.shareButton.addEventListener('click', () => {
          navigator.share({ url: this.getUrl(), title: document.title }).catch(function () {});
        });
        return;
      }
      if (!this.details) return;
      this.details.addEventListener('toggle', () => {
        if (this.details.open) return;
        if (this.successMessage) {
          this.successMessage.classList.add('hidden');
          this.successMessage.textContent = '';
        }
        if (this.closeButton) this.closeButton.classList.add('hidden');
        if (this.summary) this.summary.focus();
      });
      if (this.copyButton) this.copyButton.addEventListener('click', () => this.copyToClipboard());
      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => {
          this.details.removeAttribute('open');
          if (this.summary) this.summary.setAttribute('aria-expanded', 'false');
        });
      }
      this.details.addEventListener('keyup', (event) => {
        if (event.code && event.code.toUpperCase() === 'ESCAPE') this.details.removeAttribute('open');
      });
      document.addEventListener('click', (event) => {
        if (this.details.open && !this.contains(event.target)) this.details.removeAttribute('open');
      });
    }

    disconnectedCallback() {
      document.removeEventListener('gz:variant-change', this.onVariantChange);
    }

    getUrl() {
      return this.urlInput ? this.urlInput.value : document.location.href;
    }

    copyToClipboard() {
      var url = this.getUrl();
      var onSuccess = () => {
        var strings = window.accessibilityStrings || {};
        if (this.successMessage) {
          this.successMessage.classList.remove('hidden');
          this.successMessage.textContent = strings.shareSuccess || 'Link copied to clipboard!';
        }
        if (this.closeButton) {
          this.closeButton.classList.remove('hidden');
          this.closeButton.focus();
        }
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(onSuccess, () => this.fallbackCopy(onSuccess));
      } else {
        this.fallbackCopy(onSuccess);
      }
    }

    fallbackCopy(onSuccess) {
      if (!this.urlInput) return;
      this.urlInput.select();
      try {
        if (document.execCommand('copy')) onSuccess();
      } catch (e) {
        /* nothing else to try */
      }
    }

    updateUrl(url) {
      if (this.urlInput) this.urlInput.value = url;
    }

    onVariantChange(event) {
      var detail = event.detail || {};
      if (!detail.variant || detail.sectionId !== this.id.replace('Share-', '')) return;
      try {
        var url = new URL(this.getUrl(), window.location.origin);
        url.searchParams.set('variant', detail.variant.id);
        this.updateUrl(url.toString());
      } catch (e) {
        /* invalid url in markup */
      }
    }
  }
  define('gz-share-button', GzShareButton);

  /* ---------- gz-pickup-availability ---------- */

  class GzPickupAvailability extends HTMLElement {
    constructor() {
      super();
      this.onVariantChange = this.onVariantChange.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
    }

    connectedCallback() {
      document.addEventListener('gz:variant-change', this.onVariantChange);
      if (this._pickupInit) return;
      this._pickupInit = true;
      var template = this.querySelector('template');
      this.errorHtml = template && template.content.firstElementChild ? template.content.firstElementChild.cloneNode(true) : null;
      if (this.hasAttribute('available')) this.fetchAvailability(this.dataset.variantId);
    }

    disconnectedCallback() {
      document.removeEventListener('gz:variant-change', this.onVariantChange);
      this.removeDrawer();
    }

    onVariantChange(event) {
      var detail = event.detail || {};
      if (detail.sectionId !== sectionIdOf(this)) return;
      this.update(detail.variant);
    }

    update(variant) {
      if (variant && variant.available) {
        this.dataset.variantId = variant.id;
        this.fetchAvailability(variant.id);
      } else {
        this.removeAttribute('available');
        this.innerHTML = '';
        this.removeDrawer();
      }
    }

    fetchAvailability(variantId) {
      if (!variantId) return;
      var rootUrl = this.dataset.rootUrl || '/';
      if (rootUrl.slice(-1) !== '/') rootUrl += '/';
      var token = (this._requestToken = {});
      fetch(rootUrl + 'variants/' + variantId + '/?section_id=pickup-availability')
        .then((response) => response.text())
        .then((text) => {
          if (token !== this._requestToken) return;
          this.renderPreview(parseHTML(text).querySelector('.shopify-section'));
        })
        .catch(() => {
          if (token === this._requestToken) this.renderError();
        });
    }

    renderError() {
      this.innerHTML = '';
      this.removeDrawer();
      if (!this.errorHtml) return;
      this.appendChild(this.errorHtml.cloneNode(true));
      var button = this.querySelector('button');
      if (button) button.addEventListener('click', () => this.fetchAvailability(this.dataset.variantId));
    }

    renderPreview(section) {
      this.removeDrawer();
      var preview = section && section.querySelector('pickup-availability-preview, gz-pickup-availability-preview');
      if (!preview) {
        this.innerHTML = '';
        this.removeAttribute('available');
        return;
      }
      this.innerHTML = preview.outerHTML;
      this.setAttribute('available', '');

      var drawer = section.querySelector('pickup-availability-drawer');
      if (drawer) {
        // Keep the drawer inside the .gz-scope section so the scoped CSS applies.
        var host = this.closest('.gz-scope') || document.body;
        this.drawer = document.importNode(drawer, true);
        host.appendChild(this.drawer);
        var close = this.drawer.querySelector('button');
        if (close) close.addEventListener('click', () => this.hideDrawer());
        this.drawer.addEventListener('keyup', (event) => {
          if (event.code && event.code.toUpperCase() === 'ESCAPE') this.hideDrawer();
        });
      }
      var button = this.querySelector('button');
      if (button && this.drawer) button.addEventListener('click', (event) => this.showDrawer(event.currentTarget));
    }

    showDrawer(focusElement) {
      if (!this.drawer) return;
      this.focusElement = focusElement;
      this.drawer.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
      setTimeout(() => document.body.addEventListener('click', this.onBodyClick));
      doTrapFocus(this.drawer, this.drawer.querySelector('button'));
    }

    hideDrawer() {
      if (!this.drawer || !this.drawer.hasAttribute('open')) return;
      this.drawer.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClick);
      document.body.classList.remove('overflow-hidden');
      doRemoveTrapFocus(this.focusElement);
    }

    onBodyClick(event) {
      if (this.drawer && !this.drawer.contains(event.target)) this.hideDrawer();
    }

    removeDrawer() {
      if (!this.drawer) return;
      this.hideDrawer();
      this.drawer.remove();
      this.drawer = null;
    }
  }
  define('gz-pickup-availability', GzPickupAvailability);

  // Preview markup is static once rendered; defined so the tag is upgraded/styled consistently.
  class GzPickupAvailabilityPreview extends HTMLElement {}
  define('gz-pickup-availability-preview', GzPickupAvailabilityPreview);

  /* ---------- gz-product-recommendations ---------- */

  class GzProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this._loaded || !this.dataset.url) return;
      if (!('IntersectionObserver' in window)) {
        this.load();
        return;
      }
      if (this._io) this._io.disconnect();
      this._io = new IntersectionObserver(
        (entries, observer) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          observer.disconnect();
          this.load();
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      this._io.observe(this);
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
    }

    load() {
      if (this._loaded) return;
      this._loaded = true;
      var url = this.dataset.url;
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          var doc = parseHTML(text);
          // Several recommendation blocks may share a section (complementary + upsell): match
          // ours by identical data-url, then by position.
          var peers = qsa('gz-product-recommendations').filter((el) => el.dataset.url === url);
          var candidates = qsa('gz-product-recommendations', doc);
          var sameUrl = candidates.filter((el) => el.dataset.url === url);
          if (sameUrl.length) candidates = sameUrl;
          else if (this.classList.contains('complementary-products')) {
            candidates = candidates.filter((el) => el.classList.contains('complementary-products'));
          }
          var source = candidates[Math.max(peers.indexOf(this), 0)] || candidates[0];

          if (source && source.innerHTML.trim().length) this.innerHTML = source.innerHTML;

          if (this.classList.contains('complementary-products') && !this.querySelector('gz-slideshow-component')) {
            this.remove();
            return;
          }
          if (this.querySelector('.grid__item, .card-wrapper, .upsell')) this.classList.add('product-recommendations--loaded');
        })
        .catch((e) => {
          this._loaded = false;
          console.error(e);
        });
    }
  }
  define('gz-product-recommendations', GzProductRecommendations);

  /* ---------- sticky add to cart ---------- */

  class GzStickyAtc extends HTMLElement {
    constructor() {
      super();
      this.onVariantChange = this.onVariantChange.bind(this);
    }

    connectedCallback() {
      document.addEventListener('gz:variant-change', this.onVariantChange);
      if (this._stickyInit) {
        this.setupVisibility();
        return;
      }
      this._stickyInit = true;
      this.section = this.dataset.section;

      this.addEventListener('click', (event) => {
        var scrollBtn = event.target.closest('.sticky-atc__scroll-btn');
        if (scrollBtn) {
          event.preventDefault();
          this.scrollToDestination();
          return;
        }
        var atc = event.target.closest('.main-product-atc');
        if (!atc || atc.disabled) return;
        event.preventDefault();
        if (this.dataset.scrollBtn === 'true') this.scrollToDestination();
        else triggerMainAtc(this.section, atc);
      });

      this.setupVisibility();
    }

    disconnectedCallback() {
      document.removeEventListener('gz:variant-change', this.onVariantChange);
      if (this._io) this._io.disconnect();
    }

    setupVisibility() {
      if (this._io) this._io.disconnect();
      if (this.dataset.afterScroll !== 'true') {
        this.setVisible(true);
        return;
      }
      var target =
        document.getElementById('ProductSubmitButton-' + this.section) ||
        document.getElementById('ProductInfo-' + this.section);
      if (!target || !('IntersectionObserver' in window)) {
        this.setVisible(true);
        return;
      }
      this.setVisible(false);
      this._io = new IntersectionObserver((entries) => {
        var entry = entries[entries.length - 1];
        this.setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
      this._io.observe(target);
    }

    setVisible(visible) {
      if (this.dataset.afterScroll === 'true') this.style.transform = visible ? 'none' : '';
      this.classList.toggle('sticky-atc--visible', visible);
      if ('inert' in this) this.inert = !visible;
      if (visible) this.removeAttribute('aria-hidden');
      else this.setAttribute('aria-hidden', 'true');
    }

    scrollToDestination() {
      var dest = this.dataset.scrollDestination || '#ProductInfo-id';
      dest = dest.replace(/-id$/, '-' + this.section);
      var target = null;
      try {
        var section = this.closest('.shopify-section');
        target = (section && section.querySelector(dest)) || document.querySelector(dest);
      } catch (e) {
        target = null;
      }
      scrollToElement(target || document.getElementById('ProductInfo-' + this.section));
    }

    onVariantChange(event) {
      var detail = event.detail || {};
      if (detail.sectionId !== this.section) return;
      var html = detail.html;
      var variant = detail.variant;

      if (html && variant) {
        var priceId = 'sticky-atc-separate-price-' + this.section;
        var oldPrice = document.getElementById(priceId);
        var newPrice = html.getElementById(priceId);
        if (oldPrice && newPrice) {
          oldPrice.innerHTML = newPrice.innerHTML;
          ['data-base-price', 'data-base-compare-price'].forEach(function (attr) {
            if (newPrice.hasAttribute(attr)) oldPrice.setAttribute(attr, newPrice.getAttribute(attr));
          });
        }
        var oldButtonWrap = this.querySelector('.sticky-atc__button');
        var newSticky = html.getElementById(this.id);
        var newButtonWrap = newSticky && newSticky.querySelector('.sticky-atc__button');
        if (oldButtonWrap && newButtonWrap) oldButtonWrap.innerHTML = newButtonWrap.innerHTML;
      } else if (!variant) {
        var btn = this.querySelector('.main-product-atc');
        if (btn) btn.setAttribute('disabled', 'disabled');
      }

      var img = document.getElementById('sticky-atc-image-' + this.section);
      var media = variant && (variant.featured_media || null);
      var src = (media && media.preview_image && media.preview_image.src) || (variant && variant.featured_image && variant.featured_image.src);
      if (img && src) {
        try {
          var url = new URL(src, window.location.origin);
          url.searchParams.set('width', '500');
          img.src = url.toString();
        } catch (e) {
          img.src = src;
        }
        var alt = (media && media.alt) || (variant.featured_image && variant.featured_image.alt);
        if (alt) img.alt = alt;
      }
    }
  }
  define('gz-sticky-atc', GzStickyAtc);

  /* ---------- sticky ATC variant pickers ---------- */

  function applyOptionsToMain(sectionId, options) {
    var main = document.querySelector('gz-variant-selects[data-section="' + sectionId + '"]');
    if (!main || !options) return;
    var groups = Array.prototype.filter.call(main.children, (el) => el.classList.contains('product-form__input'));
    var last = null;
    options.forEach(function (value, index) {
      var group = groups[index];
      if (!group || value == null) return;
      var select = group.querySelector('select');
      if (select) {
        if (select.value !== value) {
          select.value = value;
          last = select;
        }
        return;
      }
      var radio = qsa('input[type="radio"]', group).find((r) => r.value === value);
      if (radio && !radio.checked) {
        radio.checked = true;
        last = radio;
      }
    });
    if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
  }

  class GzSecondaryVariantSelect extends HTMLElement {
    constructor() {
      super();
      this.onVariantChange = this.onVariantChange.bind(this);
    }

    connectedCallback() {
      document.addEventListener('gz:variant-change', this.onVariantChange);
      if (this._secInit) return;
      this._secInit = true;
      this.addEventListener('change', (event) => {
        if (!event.target.matches('select')) return;
        // Keep these selects (they carry form="product-form-…") from being treated as main picker input.
        event.stopPropagation();
        applyOptionsToMain(this.dataset.section, this.getSelectedOptions());
      });
    }

    disconnectedCallback() {
      document.removeEventListener('gz:variant-change', this.onVariantChange);
    }

    getVariants() {
      if (!this._variants) {
        var script = this.querySelector('script[type="application/json"]');
        try {
          this._variants = script ? JSON.parse(script.textContent) : [];
        } catch (e) {
          this._variants = [];
        }
      }
      return this._variants;
    }

    getSelects() {
      return qsa('select', this);
    }

    getSelectedOptions() {
      var select = this.getSelects()[0];
      if (!select) return null;
      var variant = this.getVariants()[select.selectedIndex];
      if (variant && variant.options) return variant.options;
      var opt = select.options[select.selectedIndex];
      return opt ? (opt.dataset.options || opt.value).split(',') : null;
    }

    onVariantChange(event) {
      var detail = event.detail || {};
      if (detail.sectionId !== this.dataset.section || !detail.variant) return;
      this.syncFrom(detail.variant, detail.html);
    }

    syncFrom(variant) {
      var select = this.getSelects()[0];
      if (!select) return;
      var index = this.getVariants().findIndex((v) => v.id === variant.id);
      if (index > -1 && select.selectedIndex !== index) select.selectedIndex = index;
    }
  }
  define('gz-secondary-variant-select', GzSecondaryVariantSelect);

  class GzSecondaryVariantSelectSeparate extends GzSecondaryVariantSelect {
    getSelectedOptions() {
      return this.getSelects().map((select) => select.value);
    }

    syncFrom(variant, html) {
      var selects = this.getSelects();
      var fresh = html && this.id ? html.getElementById(this.id) : null;
      var freshSelects = fresh ? qsa('select', fresh) : [];
      selects.forEach((select, index) => {
        if (freshSelects[index]) select.innerHTML = freshSelects[index].innerHTML;
        var value = variant.options ? variant.options[index] : null;
        if (value != null) select.value = value;
      });
    }
  }
  define('gz-secondary-variant-select-separate', GzSecondaryVariantSelectSeparate);
})();
